import React, { FC } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { UI_ModuleDocuments } from "../../../../../UI_ITO/indexUI";
import { TagSign } from "../TagSign/TagSign";
import { useParams } from "react-router-dom";
import { applicationBankDocumentsApi } from "../../../../../services/documents/documents.api";
import { useAppDispatch } from "../../../../../store/reduxHooks";
import { OPEN_SIGN_INFO_MODAL } from "../../../../../store/slices/applicationBankSlice/applicationBankSlice";
import { getClientSign } from "../../../../../utils/utilities/documents/getClientSign";
import { MainDocument } from "../../../../../types/documents.type";
import { GetSignInfoQueryParams } from "../../../../../store/api/applicationBankApi/signing.api";

interface ApplicationDetailsDoсSectionProps {
  documents: MainDocument[];
}

const { downloadDocument, downloadDocumentSignFile } =
  applicationBankDocumentsApi;

const ApplicationDetailsDoсSection: FC<ApplicationDetailsDoсSectionProps> = ({
  documents,
}) => {
  const { applicationBankId } = useParams();

  const dispatch = useAppDispatch();

  const openSignInfoModal = (params: GetSignInfoQueryParams) => {
    dispatch(OPEN_SIGN_INFO_MODAL(params));
  };

  return (
    <div style={{ paddingBottom: "24px" }}>
      {Array.isArray(documents) &&
        documents?.map((document) => {
          const clientSignFile = getClientSign(document.document || null);
          return (
            <div key={document.name + document.id}>
              <UI_ModuleDocuments
                title={document.name}
                titleDown={
                  document.document?.name ? (
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (document.document && applicationBankId) {
                          downloadDocument({
                            applicationBankId: Number(applicationBankId),
                            fileId: document.document.id,
                            fileName: document.document.name,
                          });
                        }
                      }}
                    >
                      {document.document.name}
                    </span>
                  ) : (
                    "Документ не загружен"
                  )
                }
                icon={
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        gap: "10px",
                      }}
                    >
                      <TagSign
                        tag={clientSignFile ? "sign_true" : "sign_false"}
                        onClickDownload={() => {
                          if (
                            document.document &&
                            applicationBankId &&
                            clientSignFile
                          ) {
                            downloadDocumentSignFile({
                              applicationBankId: Number(applicationBankId),
                              fileId: document.document.id,
                              signId: clientSignFile.id,
                              fileName: clientSignFile.name,
                            });
                          }
                        }}
                        onClickSignInfo={() => {
                          if (
                            document.document &&
                            applicationBankId &&
                            clientSignFile
                          ) {
                            openSignInfoModal({
                              applicationBankId: Number(applicationBankId),
                              fileId: document.document.id,
                              signId: clientSignFile.id,
                            });
                          }
                        }}
                      />
                    </div>
                    <DownloadOutlined
                      style={{ color: "black" }}
                      onClick={() => {
                        if (document.document && applicationBankId) {
                          downloadDocument({
                            applicationBankId: Number(applicationBankId),
                            fileId: document.document.id,
                            fileName: document.document.name,
                          });
                        }
                      }}
                    />
                  </>
                }
              />
            </div>
          );
        })}
    </div>
  );
};

export default ApplicationDetailsDoсSection;
